import React, { memo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Text, StackProps, Flex, IconButton } from "@chakra-ui/react"

import { Icon } from "@app/components/Icon"

type Props = StackProps & {
  handleChange: (quantity: number) => void
  max?: number
  value: number
  backgroundColour?: string
}

export const ProductFormQuantity: React.FC<Props> = memo(({ handleChange, max, value, backgroundColour }) => {
  const { cart } = useStaticQuery<GatsbyTypes.StaticFormQuantityQuery>(graphql`
    query StaticFormQuantity {
      cart: sanityPageCart {
        additionalIncrease
        additionalDecrease
      }
    }
  `)

  return (
    <Flex border="1px solid" borderColor="grey.mid" gap={1} borderRadius="8px" backgroundColor={backgroundColour}>
      <IconButton
        isDisabled={value === 1}
        onClick={() => handleChange(value - 1)}
        title={cart?.additionalDecrease}
        aria-label={cart?.additionalDecrease}
        variant="quantitySelector"
        icon={<Icon name="dash" w={4} />}
        w={12}
        p={3}
      />

      <Text alignSelf="center" size="sm" textAlign="center" color="grey.darkest" minW={5}>
        {value}
      </Text>
      <IconButton
        isDisabled={(max !== undefined && value >= max) || false}
        onClick={() => handleChange(value + 1)}
        title={cart?.additionalIncrease}
        aria-label={cart?.additionalIncrease}
        variant="quantitySelector"
        icon={<Icon name="plus" w={4} />}
        w={12}
        p={3}
      />
    </Flex>
  )
})
